<template>
  <div>
    <b-card no-body>
      <b-row class="mx-1 mt-2 mb-1" align-h="between">
        <b-col lg="10" md="10" sm="12">
          <b-row align-h="between" align-v="middle">
            <b-col lg="2" md="5" sm="12" class="mb-1 mt-0-5 ml-1 d-flex align-items-center">
              <div class="form-select">
                Show
                <b-form-select
                  value="10"
                  v-on:change="getSelectedPageSize"
                  :options="options"
                  style="width: 60px;"
                  size="sm"
                ></b-form-select>
                Entries
              </div>
            </b-col>
            <b-col v-if="!isAlertType" lg="2" md="5" sm="12" class="mb-1 mt-0-5 ml-3 d-flex align-items-center">
              <b-form-select
                v-model="selectedZoneOption"
                :options="zoneOptions"
                style="width: 160px;"
                size="sm"
              ></b-form-select>
            </b-col>
            <b-col v-if="!isAlertType" lg="2" md="5" sm="12" class="mb-1 mt-0-5 ml-3 d-flex align-items-center">
              <b-form-select
                v-model="selectedSecurityOption"
                :options="securityOptions"
                style="width: 160px;"
                size="sm"
              ></b-form-select>
            </b-col>
            <b-col v-if="!isAlertType" lg="2" md="5" sm="12" class="mb-1 mt-0-5 ml-3 pt-0-5 d-flex align-items-center">
              <div class="abnormal-select">
                <b-form-checkbox v-model="showAbnormalOnly" size="md">
                  Only Abnormal
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col v-if="!isAlertType" lg="2" md="5" sm="12" class="mb-1 mt-0-5 ml-3 d-flex align-items-center">
              <div class="abnormal-select">
                <b-form-checkbox v-model="showThreatFeedsOnly" size="md">
                  Only Threat Feeds
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="2" md="2" sm="12" class="mb-1 d-flex align-items-center justify-content-end">
          <b-row>
            <SearchBar>
              <template #input>
                <b-form-input v-model="filter" type="search" placeholder="Search" />
              </template>
            </SearchBar>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div v-if="hasData">
            <b-table
              class="table-with-actions-min-height px-2"
              responsive
              striped
              outlined
              :items="serverFilter"
              :fields="computedTableFields"
              :per-page="perPage"
              :current-page="currentPage"
              select-mode="single"
              selectable
              @row-selected="onRowSelected"
            >
              <template #cell(ip)="row">
                <IpWrapper
                  :ip="row.value"
                  :timeRange="timeRange"
                >
                </IpWrapper>
              </template>
              <template #head(totalCount)="data">
                <span v-b-tooltip.hover>
                  {{ data.label }}
                </span>
              </template>
              <template #cell(asn)="row">
                <span v-b-tooltip.hover :title="row.value">
                  {{ collapseText(row.value, 48)}}
                </span>
              </template>
              <template #cell(behavior)="row">
                <SecurityBehavior :behavior="row.value"></SecurityBehavior>
              </template>
              <template #cell(totalBytes)="row">
                {{ readableBytes(row.value) }}
              </template>
              <template #cell(threatFeeds)="row">
                <ThreatFeedIcons
                  :threatFeedInfo="row.item.threatFeeds"
                  :threatFeedTypes="threatFeedTypes"
                  :uniqueId="row.item.ip">
                </ThreatFeedIcons>
              </template>
              <template #cell(moreActions)="row">
                <MoreActions
                  v-if="isXomeXpcapLoaded"
                  :xomeId="row.item.xomeId"
                  :ip="row.item.ip"
                  :timeRange="timeRange"
                  :showPcapDownloadOption = "showPcapDownloadOption(row.item.xomeId)"
                />
              </template>
            </b-table>
            <b-row>
              <b-col>
                <h5
                  class="mb-2 mx-1 text-right"
                >
                  <span
                    class="total-addresses-wrapper"
                    v-b-tooltip.hover
                    :title="getTotalAddressesTooltip"
                  >
                    Total Addresses: {{ addressesInfo.addressesCount }}
                  </span>
                </h5>
              </b-col>
              <b-col>
                <ArrowPagination
                  :nextPageAvailable="nextPageAvailable"
                  :totalItemsCount="addressesInfo.addressesCount"
                  :currentPageCount="this.topServers.length"
                  :paginationParams="paginationParams"
                  :sortOptions="paginationSortOptions"
                >
                </ArrowPagination>
              </b-col>
            </b-row>
          </div>
          <div v-else-if="loaded" class="mx-1 pl-1 mb-1">
            {{ $t("No Data Available") }}
          </div>
          <SpinnerCmpt v-else class="mb-1"></SpinnerCmpt>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import Please from 'pleasejs';

import ArrowPagination from '@/xvisor/components/ArrowPagination.vue';
import IpWrapper from '@/xvisor/components/IpWrapper.vue';
import MoreActions from '@/xvisor/components/security/MoreActions.vue';
import SearchBar from '@/xvisor/components/SearchBar.vue';
import SecurityBehavior from '@/xvisor/components/security/SecurityBehavior.vue';
import SecurityEventBus from '@/xvisor/bus/SecurityEventBus';
import SpinnerCmpt from '@/xvisor/components/SpinnerCmpt.vue';
import collapseText from '@/xvisor/utilities/collapseText';
import hostnameFormatter from '@/xvisor/utilities/hostnameFormatter';
import securityOptions from '@/xvisor/constants/securityOptions';
import threatRole from '@/xvisor/constants/threatRole';
import trafficType from '@/xvisor/constants/trafficType';
import ThreatFeedIcons from '@/xvisor/components/ThreatFeedIcons.vue';
import readableBytes from '@/xvisor/utilities/readableBytes';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    addressCountUrl: {
      type: String,
      required: true,
    },
    getZonesUrl: {
      type: String,
      required: true,
    },
    serviceType: {
      type: String,
      required: true,
    },
  },
  components: {
    ArrowPagination,
    IpWrapper,
    MoreActions,
    SearchBar,
    SecurityBehavior,
    SpinnerCmpt,
    ThreatFeedIcons,
  },
  data() {
    return {
      zones: [],
      xomeXpcap: {},
      isXomeXpcapLoaded: false,
      currentPage: 1,
      deletePitUrl: '/security/pit/delete',
      paginationParams: {
        from: 0,
        size: 10,
        pitId: '',
        sortField: 'totalCount',
        desc: true,
      },
      nextPageAvailable: false,
      options: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
      ],
      paginationSortOptions: [
        { label: 'Highest Total Count', sortField: 'totalCount', desc: true },
        { label: 'Lowest Total Count', sortField: 'totalCount', desc: false },
        { label: 'Highest Total Bytes', sortField: 'totalBytes', desc: true },
        { label: 'Lowest Total Bytes', sortField: 'totalBytes', desc: false },
      ],
      // TODO: Change default back to enterprise servers when data is available.
      selectedSecurityOption: securityOptions.allClients.value,
      selectedZoneOption: null,
      selectedThreatFilters: [],
      securityOptions: Object.values(securityOptions),
      showAbnormalOnly: false,
      showThreatFeedsOnly: false,
      threatFeedTypes: {
        all: {
          name: 'Select All',
          type: 'all',
        },
      },
      getNewPitUrl: '/es/pit/createid',
      getThreatFeedsUrl: '/security/threatfeeds.json',
      filter: null,
      tableFields: [
        { key: 'ip', label: 'IP Address', sortable: false },
        { key: 'asn', label: 'ASN', sortable: true },
        { key: 'country', label: 'Country', sortable: true },
        { key: 'totalCount', label: 'Total Count', sortable: true },
        { key: 'totalBytes', label: 'Total Bytes', sortable: true },
        { key: 'threatFeeds', label: 'Threat', sortable: false },
        { key: 'behavior', label: 'Behavior', sortable: true },
        { key: 'moreActions', label: '', sortable: false },
      ],
      topServers: [],
      addressesInfo: {},
      loaded: false,
      selected: [],
      searchText: '',
      trafficType,
    };
  },
  computed: {
    hasData() {
      return this.loaded && this.topServers && this.topServers.length > 0;
    },
    selectedRole() {
      return this.selectedSecurityOption.role;
    },
    selectedScope() {
      return this.selectedSecurityOption.scope;
    },
    selectedAbnormal() {
      return this.showAbnormalOnly;
    },
    selectedThreatFeeds() {
      return this.showThreatFeedsOnly;
    },
    selectedFiltersChange() {
      return [
        this.selectedSecurityOption.role,
        this.selectedSecurityOption.scope,
        this.showAbnormalOnly,
        this.showThreatFeedsOnly,
        this.selectedZoneOption,
      ];
    },
    zoneOptions() {
      return [
        { value: null, text: 'Select a zone' },
        ...this.zones.map((zone) => ({ value: zone.id, text: zone.name })),
      ];
    },
    // A separate table field is required for the DNS component since DNS doesn't have BPS information.
    computedTableFields() {
      const filtered = this.tableFields;
      if (this.serviceType === trafficType.dns.value) {
        return filtered.filter((field) => field.key !== 'bitsPerSecond');
      }
      return filtered;
    },
    serverFilter() {
      return this.topServers.filter((server) => this.includeBySelectedThreatType(server));
    },
    isAlertType() {
      return this.serviceType === trafficType.alert.value;
    },
    columnNames() {
      if (this.serviceType === trafficType.dns.value) {
        return {
          context: 'TLD Queried',
          contextTooltip: 'Top level domain frequently queried',
          hostname: 'Hostname(s)',
          hostnameTooltip: 'Name(s) associated with address',
        };
      }
      if (this.serviceType === trafficType.alert.value) {
        return {
          context: 'Server',
          contextTooltip: 'Frequent Server of Client',
          hostname: 'Hostname(s)',
          hostnameTooltip: 'Name(s) associated with address',
        };
      }
      if (this.selectedRole === threatRole.server.value) {
        return {
          context: 'Client',
          contextTooltip: 'Frequent Client of Server',
          hostname: 'Hostname(s)',
          hostnameTooltip: 'Name(s) associated with address',
        };
      }
      if (this.selectedRole === threatRole.client.value) {
        return {
          context: 'Server',
          contextTooltip: 'Frequent Server of Client',
          hostname: 'Hostname(s)',
          hostnameTooltip: 'Name(s) associated with address',
        };
      }
      return {
        context: 'Client',
        contextTooltip: 'Frequent client of server',
        hostname: 'Hostname(s)',
        hostnameTooltip: 'Name(s) associated with address',
      };
    },
    getTotalAddressesTooltip() {
      const roleMap = {
        server: 'Server',
        client: 'Client',
      };
      const scopeMap = {
        enterprise: 'Enterprise',
        internet: 'Internet',
        all: 'Enterprise and Internet',
      };
      const selectedRole = roleMap[this.selectedSecurityOption.role];
      const selectedScope = scopeMap[this.selectedSecurityOption.scope];
      return `Count of All Unique ${selectedScope} ${selectedRole} Addresses`;
    },
    getAddressCountParams() {
      return {
        params: {
          start: this.timeRange.start.toISOString(),
          end: this.timeRange.end.toISOString(),
          role: this.selectedRole,
          scope: this.selectedScope,
          zoneId: this.selectedZoneOption,
          abnormal: this.showAbnormalOnly,
          threatFeeds: this.showThreatFeedsOnly,
          searchtext: this.filter,
        },
      };
    },
    getThreatAnalyticsParams() {
      return {
        params: {
          start: this.timeRange.start.toISOString(),
          end: this.timeRange.end.toISOString(),
          role: this.selectedRole,
          scope: this.selectedScope,
          zoneId: this.selectedZoneOption,
          abnormal: this.showAbnormalOnly,
          threatFeeds: this.showThreatFeedsOnly,
          searchtext: this.filter,
          from: this.paginationParams.from, // If less than or equal to 0, disable prev page arrow.
          size: this.paginationParams.size + 1, // Determine whether to disable next page arrow.
          pitId: this.paginationParams.pitId,
          sortField: this.paginationParams.sortField,
          desc: this.paginationParams.desc,
        },
      };
    },
    getZonesParams() {
      return {
        params: {
          start: this.timeRange.start.toISOString(),
          end: this.timeRange.end.toISOString(),
        },
      };
    },
    showPcapDownloadForTimeRange() {
      const hourToMs = 3600000;
      const show = (this.timeRange.end.getTime() - this.timeRange.start.getTime()) <= (6 * hourToMs);
      return show;
    },
  },
  mounted() {
    this.getPitId();
    this.getXomeXpcap();
  },
  methods: {
    getPitId() {
      this.$http
        .get(this.getNewPitUrl, {
          params: {
            indexName: 'threat-analytics-v2',
            version: 8,
          },
        })
        .then((response) => {
          const { id } = response.data;
          this.paginationParams.pitId = id;
        });
    },
    deletePitId() {
      if (this.paginationParams.pitId !== '') {
        this.$http.delete(this.deletePitUrl, {
          params: {
            id: this.paginationParams.pitId,
          },
        });
      }
    },
    httpGet() {
      this.loaded = false;
      axios
        .all([
          this.$http.get(this.url, this.getThreatAnalyticsParams),
          this.$http.get(this.addressCountUrl, this.getAddressCountParams),
          this.$http.get(this.getThreatFeedsUrl),
          this.$http.get(this.getZonesUrl, this.getZonesParams),
        ])
        .then(axios.spread((topServRes, addressCountRes, threatFeedsRes, zonesRes) => {
          if (topServRes.data.length > this.paginationParams.size) {
            this.nextPageAvailable = true;
            this.topServers = topServRes.data.slice(0, this.paginationParams.size);
          } else {
            this.nextPageAvailable = false;
            this.topServers = topServRes.data;
          }
          this.addressesInfo = addressCountRes.data;
          // Store possible threat types in a key-value object.
          threatFeedsRes.data.forEach((val) => { this.threatFeedTypes[val.type] = val; });
          this.getThreatIconColors();
          this.zones = zonesRes.data;
        }))
        .finally(() => { this.loaded = true; });
    },
    getXomeXpcap() {
      this.isXomeXpcapLoaded = false;
      this.$http
        .get('settings/xomes/info.json')
        .then((response) => {
          response.data.forEach((xome) => { this.xomeXpcap[xome.id] = xome.xpcap; });
        })
        .finally(() => { this.isXomeXpcapLoaded = true; });
    },
    showPcapDownloadOption(xomeId) {
      const xpcapEnabledForXome = this.xomeXpcap[xomeId] ?? false;
      // Only show the download option if the time range is short enough and if xpcap is enabled for the XOME.
      return this.showPcapDownloadForTimeRange && xpcapEnabledForXome;
    },
    getSelectedPageSize(selected) {
      this.paginationParams.from = 0;
      this.paginationParams.size = selected;
    },
    contextFormatting(context) {
      if (this.serviceType === trafficType.dns.value || this.serviceType === trafficType.other.value) {
        return context;
      }
      return this.removePortFromString(context);
    },
    resetPaginationParams() {
      this.selected = [];
      this.paginationParams = {
        ...this.paginationParams,
        from: 0,
      };
    },
    removePortFromString(str) {
      const index1 = str.indexOf('(');
      if (index1 < 0) {
        return str;
      }
      return str.substring(0, index1 - 1);
    },
    includeBySelectedThreatType(server) {
      if ((!this.selectedThreatFilters.length)
        || (this.selectedThreatFilters[0] === 'all' && server.threatFeeds && server.threatFeeds.length > 0)
        || (server.threatFeeds && this.threatTypeExists(server.threatFeeds))) {
        return true;
      }
      return false;
    },
    onRowSelected(items) {
      this.selected = [
        {
          ...items[0],
          scope: this.selectedScope,
        },
      ];
    },
    threatTypeExists(threatFeeds) {
      let threatMatches = true;
      this.selectedThreatFilters.forEach((threat) => {
        threatMatches = threatFeeds.includes(threat);
      });
      return threatMatches;
    },
    getThreatIconColors() {
      const feedTypesLength = Object.keys(this.threatFeedTypes).length;
      const hsvs = [
        {
          h: 24,
          s: 1,
          v: 0.5,
        },
        {
          h: 220,
          s: 1,
          v: 0.7,
        },
        {
          h: 264,
          s: 1,
          v: 0.5,
        },
      ];
      const allColors = hsvs.map((hsv) => {
        const scheme = Please.make_scheme(
          hsv,
          {
            scheme_type: 'analogous',
            format: 'hex',
          },
        );
        return scheme;
      }).flat();
      const randomColors = allColors.sort(() => 0.5 - Math.random()).slice(0, feedTypesLength);
      Object.keys(this.threatFeedTypes).forEach((key, index) => {
        this.threatFeedTypes[key].style = randomColors[index];
      });
    },
    collapseText,
    hostnameFormatter,
    readableBytes,
  },
  watch: {
    paginationParams: {
      handler() {
        if (this.paginationParams.pitId !== '') {
          this.loaded = false;
          axios
            .all([
              this.$http.get(this.url, this.getThreatAnalyticsParams),
              this.$http.get(this.addressCountUrl, this.getAddressCountParams),
              this.$http.get(this.getThreatFeedsUrl),
              this.$http.get(this.getZonesUrl, this.getZonesParams),
            ])
            .then(axios.spread((topServRes, addressCountRes, threatFeedsRes, zonesRes) => {
              if (topServRes.data.length > this.paginationParams.size) {
                this.nextPageAvailable = true;
                this.topServers = topServRes.data.slice(0, this.paginationParams.size);
              } else {
                this.nextPageAvailable = false;
                this.topServers = topServRes.data;
              }
              this.addressesInfo = addressCountRes.data;
              // Store possible threat types in a key-value object.
              threatFeedsRes.data.forEach((val) => { this.threatFeedTypes[val.type] = val; });
              this.getThreatIconColors();
              this.zones = zonesRes.data;
            }))
            .catch(() => {
              this.resetPaginationParams();
            }).finally(() => { this.loaded = true; });
        }
      },
      deep: true,
    },
    selected() {
      SecurityEventBus.$emit('update-selected-server', this.selected[0]);
    },
    selectedRole() {
      SecurityEventBus.$emit('update-selected-role', this.selectedRole);
      SecurityEventBus.$emit('update-selected-server', null);
    },
    selectedFiltersChange() {
      this.resetPaginationParams();
    },
    url() {
      this.httpGet();
    },
    filter() {
      this.resetPaginationParams();
    },
    timeRange() {
      this.httpGet();
    },
  },
};
</script>

<style scoped>
.form-select{
  min-width: 160px;
  width: 18%;
}
.abnormal-select{
  min-width: 160px;
  width: 18%;
}
</style>
